// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iR1v","right":"styles_right__3P1cQ"};